import { render, staticRenderFns } from "./RewardCategoryList.vue?vue&type=template&id=25b96d94&scoped=true&"
import script from "./RewardCategoryList.vue?vue&type=script&lang=js&"
export * from "./RewardCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./RewardCategoryList.vue?vue&type=style&index=0&id=25b96d94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b96d94",
  null
  
)

export default component.exports